import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import { Link } from "react-router-dom";
import "./navbar.css";
import { Grid } from "@mui/material";

const drawerWidth = 370;

function DrawerAppBar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      sx={{ textAlign: "center" }}
      className="mobile_drawer"
    >
      <Divider />
      <div className="mobile_spacing"></div>
      <li className="nav_mobile_con">
        <Link to={`/`} className="nav_mobile ">
          home
        </Link>
      </li>
      <li className="nav_mobile_con">
        <Link to={`/collection`} className="nav_mobile  ">
          collection
        </Link>
      </li>
      <li className="nav_mobile_con">
        <Link to={`/collection`} className="nav_mobile  ">
          activity
        </Link>
      </li>
      <li className="nav_mobile_con">
        <Link to={`/ranking`} className="nav_mobile  ">
          ranking
        </Link>
      </li>
      <li className="nav_mobile_con">
        <Link to={`/profile`} className="nav_mobile  ">
          profile
        </Link>
      </li>
      <li className="nav_mobile_con">
        <Link to={`/creator`} className="nav_mobile  ">
          creator
        </Link>
      </li>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <div className="navbar_main">
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={12} md={10} lg={10}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <AppBar component="nav" className="navbar_color" position="fixed">
              <Toolbar>
                <Grid
                  container
                  sx={{
                    justifyContent: {
                      md: "center",
                    },
                  }}
                >
                  <Grid item xs={12} sm={12} md={11} lg={11}>
                    {/* NESTED GRID */}
                    <Grid
                      container
                      sx={{
                        justifyContent: {
                          xs: "space-between",
                          lg: "space-between",
                        },
                      }}
                      alignItems="center"
                    >
                      <Grid item xs={3} sm={3} md={2} lg={1.5}>
                        <Link to={`/`}>
                          <img
                            src="./Assets/logo.png"
                            alt=""
                            className="logo_img"
                          />
                        </Link>
                      </Grid>
                      <Grid item xs={0} md={6} lg={7}>
                        <Box
                          sx={{
                            display: { xs: "none", sm: "none", md: "block" },
                          }}
                        >
                          <ul className="nav_ul">
                            <li className="nav_li">
                              <Link to={`/`} className="nav_li">
                                home
                              </Link>
                            </li>

                            <li className="nav_li">
                              <Link to={`/collection`} className="nav_li">
                                collection{" "}
                              </Link>
                            </li>
                            <li className="nav_li">
                              <Link to={`/activity`} className="nav_li">
                                activity{" "}
                              </Link>
                            </li>
                            <li className="nav_li">
                              <Link to={`/ranking`} className="nav_li">
                                ranking{" "}
                              </Link>
                            </li>
                            <li className="nav_li">
                              <Link to={`/profile`} className="nav_li">
                                profile{" "}
                              </Link>
                            </li>

                            <li className="nav_li">
                              <Link to={`/creator`} className="nav_li">
                                creators
                              </Link>
                            </li>
                          </ul>
                        </Box>
                      </Grid>

                      <Grid item xs={8} sm={6} md={3} lg={2}>
                        {/* NESTED GRID FOR MOBILE RESPONSIVE */}
                        <Grid
                          container
                          sx={{
                            justifyContent: {
                              sm: "flex-end",
                              lg: "space-between",
                            },
                          }}
                          alignItems="center"
                        >
                          <Grid item xs={11} sm={8} md={9} lg={11}>
                            {" "}
                            <div className="connect_div">
                              <Link to="/connectwallet">
                                <button className="connect_btn">
                                  connect wallet
                                </button>
                              </Link>
                            </div>
                          </Grid>
                          <Grid
                            item
                            xs={1}
                            sm={2}
                            md={0}
                            lg={1}
                            sx={{
                              display: { md: "none" },
                            }}
                          >
                            <IconButton
                              aria-label="open drawer"
                              edge="start"
                              onClick={handleDrawerToggle}
                              className="menubar_btn"
                            >
                              <MenuIcon />
                            </IconButton>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Toolbar>
            </AppBar>
            <Box component="nav">
              <Drawer
                container={container}
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                  keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                  display: { xs: "block", sm: "block" },
                  "& .MuiDrawer-paper": {
                    boxSizing: "border-box",
                    width: drawerWidth,
                  },
                }}
              >
                {drawer}
              </Drawer>
            </Box>
          </Box>
          {/* NESTED GRID */}
        </Grid>
      </Grid>
    </div>
  );
}

DrawerAppBar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default DrawerAppBar;
